<template>
  <!--
    	作者：kmdshop
    	时间：2020-04-26
    	描述：门店-编辑门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--编辑门店-->
      <div class="common-form">编辑门店</div>

      <el-form-item label="选择用户">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
            <div>{{ user_info.nickName }}</div>
          </div>
          <!-- <div>
            门店添加成功后，该用户自动成为店长
          </div> -->
        </el-row>
      </el-form-item>

      <el-form-item label="门店名称" prop="store_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.store_name" placeholder="请输入门店名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店logo">
        <el-row>
        
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.logo!=''" class="img">
            <img :src="form.logo" width="100" />
          </div>
        </el-row>
      </el-form-item>
      <!-- <el-form-item label="店长" prop="linkman" :rules="[{required: true,message: ' '}]">
        <div class="d-s-s d-c">
          <el-button @click="openGetUser" icon="el-icon-plus">选择店长</el-button>
          <ul class="d-s-s select-user">
            <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in select_list" :key="index">
              <img v-if="item.user && item.user.avatarUrl" :src="item.user.avatarUrl" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{item.user && item.user.nickName?item.user.nickName:""}}</p>
            </li>
          </ul>
        </div>
      </el-form-item> -->
      <!-- <el-form-item label="商家" prop="linkman" :rules="[{required: true,message: ' '}]">
        <div class="d-s-s d-c">
          <el-button @click="openGetSupply" icon="el-icon-plus">关联商家</el-button>
          <ul class="d-s-s select-user">
            <li class="mr10 d-c-c d-c p-10-0" >
              <img v-if="form.supplys" :src="form.supplys.image_url" class="radius" width="30" height="30" />
              <p v-if="form.supplys" class="lh18 ww100 text-ellipsis">{{form.supplys.name}}</p>
            </li>
          </ul>
        </div>
      </el-form-item> -->
      <!-- <el-form-item label="佣金比例" prop="commission_rate" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.commission_rate" placeholder="请输门店抽成比例,收益会到店长账户" class="max-w460" :max="100" :min="0">
          <template slot="append">%</template>
        </el-input>
      </el-form-item> -->
      <el-form-item label="联系人" prop="linkman" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.linkman" placeholder="请输入门店联系人" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.phone" placeholder="请输入门店联系电话" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="客服联系电话" prop="cs_phone">
        <el-input v-model="form.cs_phone" placeholder="请输入客服联系电话" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="营业开始时间" prop="shop_hours_start" >
        <el-input v-model="form.shop_hours_start" placeholder="请输入营业开始时间,例如:8:30" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="营业结束时间" prop="shop_hours_end" >
        <el-input v-model="form.shop_hours_end" placeholder="请输入营业结束时间,例如:17:30" class="max-w460"></el-input>
      </el-form-item>

      <!-- <el-form-item label="店铺二维码">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('qrcode')">选择图片</el-button>
          <div v-if="form.store_qrcode!=''" class="img">
            <img :src="form.store_qrcode" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="小程序appid" prop="store_wxappid" >
        <el-input v-model="form.store_wxappid" placeholder="请输入小程序appid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="小程序页面路径" prop="store_wxapp_url" >
        <el-input v-model="form.store_wxapp_url" placeholder="请输入小程序页面路径" class="max-w460"></el-input>
        <div class="help">不填写则直接进入首页</div>
      </el-form-item> -->
        <!-- <el-form-item label="分销级别">
          <el-radio-group v-model="form.level">
            <el-radio :label="0">经销商1</el-radio>
            <el-radio :label="1">经销商2</el-radio>
            <el-radio :label="2">经销商3</el-radio>
          </el-radio-group>
        </el-form-item> -->
      <el-form-item label="门店区域">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="详细地址" prop="address" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
        <el-form-item label="门牌号" prop="house_number" >
          <el-input v-model="form.house_number" placeholder="请输入门牌号" class="max-w460"></el-input>
        </el-form-item>
      <el-form-item label="门店坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row> 
        <el-row class="mb16">
          <el-col :span="24">
            <GetPoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></GetPoint>
          </el-col>
        </el-row>

      </el-form-item>

<!-- 选择门店服务 -->
<el-form-item label="选择门店服务">
  <el-table 
    ref="serviceTable"
    :data="service" 
    border 
    size="mini" 
    style="width: 100%;"
    @selection-change="handleSelectionChange"
  >
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column prop="code" label="编号"></el-table-column>
    <el-table-column prop="name" label="类型名称" width="200"></el-table-column>
    <el-table-column label="排序">
      <template v-slot="scope">
        <el-input 
          v-model="scope.row.sort" 
          size="mini" 
          placeholder="排序" 
          style="width: 80px;"
          @change="updateServiceSort(scope.row)"
        ></el-input>
      </template>
    </el-table-column>
  </el-table>
</el-form-item>

<!-- 已选服务列表 -->
<!-- <el-form-item label="已选服务" v-if="form.service.length > 0">
  <el-table :data="form.service" border size="mini" style="width: 100%;">
    <el-table-column prop="code" label="编号"></el-table-column>
    <el-table-column prop="name" label="类型名称" width="200"></el-table-column>
    <el-table-column prop="sort" label="排序"></el-table-column>
    <el-table-column label="操作" width="100">
      <template v-slot="scope">
        <el-button 
          type="text" 
          size="mini" 
          @click="removeService(scope.$index)"
        >删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</el-form-item> -->



      <el-form-item label="门店排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入门店排序" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="分销级别" >
        <el-select v-model="form.fx_level" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            label="直推"
            value="0">
          </el-option>
          <el-option
            label="间推"
            value="1">
          </el-option>
          <el-option
            label="次推"
            value="2">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" :rows="2" v-model="form.remark" placeholder="请输入备注" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="自提核销">
        <el-radio-group v-model="form.is_check">
          <el-radio :label="1">支持</el-radio>
          <el-radio :label="0">不支持</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="门店状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否通过">
        <el-radio-group v-model="form.audit_status">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">不通过</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="不通过理由" prop="reject_reason" v-if="form.audit_status == 2">
        <el-input v-model="form.reject_reason" placeholder="请输入不通过理由" class="max-w460"></el-input>
      </el-form-item> 

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <!--选择用户-->
    <StoreUser :storeId="Number(form.store_id)" :is_open="isOpenGetUser" :multi="false" @close="closeGetUserFunc"></StoreUser>

     <!--选择商家-->
     <SupplyX :isproduct="isOpenGetSupply" :multi="false" @closeDialog="closeGetSupplyFunc"></SupplyX>

   <!--添加-->
   <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>
  </div>
</template>

<script>
  import GetPoint from '@/components/map/Getpoint.vue';
  import StoreApi from '@/api/store.js';
  // import select_region from '@/utils/select.region.js';
  import select_region from '@/utils/select.district.js';
  import Upload from '@/components/file/Upload';
  import { formatModel } from '@/utils/base.js'
  import StoreUser from '@/components/user/StoreUser'
  import SupplyX from '@/components/supply/Supply'
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      /*腾讯地图拾取器*/
      GetPoint,
      Upload,
      StoreUser,
      SupplyX,
      GetUser
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          store_id:null,
          store_name: '',
          linkman: '',
          phone: '',
          logo:"",
          shop_hours: '',
          shop_hours_start:"",
          shop_hours_end:'',
          province_id: '',
          city_id: '',
          region_id: '',
          address: '',
          house_number:"",
          coordinate: '',
          summary: '',
          sort: '',
          is_check: '',
          status: '',
          store_qrcode: '',
          store_wxapp_url: '',
          store_wxappid: '',
          logo_image_id: 0,
          commission_rate: 0,
          supplys:{},
          audit_status:1,//1   通过  2  驳回
          reject_reason:"",//不通过理由
          cs_phone: '',
          service:[],
          level:0,
          remark:"",
          user_id: 0,
          fx_level:[]
        },
        /*省市区*/
        areaList: select_region,
        /*查询信息*/
        list: [],
        /*是否上传图片*/
        isupload: false,
        loading: false,
        file_path: '',
        // 选择用户开关
        isOpenGetUser: false,
        select_list: [],
        //选择商家开关
        isOpenGetSupply:false,
        select_list_supply:[],

        file_type:'',
        service:[],

        open_add:false,

        user_info:{}
      };
    },
    created() {
      this.form.store_id =this.$route.query.store_id
      this.getData();
      this.getSetting();
      console.log('areaList',this.areaList);
      
    },

    methods: {
         /*打开弹出层*/
         addClick() {
        this.open_add = true;
      },

     handleSelectionChange(selectedRows) {
    // 获取当前勾选的所有服务code
    const selectedCodes = selectedRows.map(row => row.code);
    
    // 1. 移除取消勾选的服务
    this.form.service = this.form.service.filter(service => 
      selectedCodes.includes(service.code)
    );
    
    // 2. 添加新勾选的服务
    selectedRows.forEach(row => {
      if (!this.form.service.some(service => service.code === row.code)) {
        this.form.service.push({
          code: row.code,
          name: row.name,
          sort: row.sort || 0
        });
      }
    });
  },
  
  // 更新服务排序
  updateServiceSort(row) {
    const service = this.form.service.find(item => item.code === row.code);
    if (service) {
      service.sort = row.sort;
    }
  },
  
  // 初始化已选服务
  initSelectedServices() {
    this.$nextTick(() => {
      // 清除所有勾选
      this.service.forEach(item => {
        this.$refs.serviceTable.toggleRowSelection(item, false);
      });
      
      // 重新勾选已存在的服务
      this.form.service.forEach(selected => {
        const service = this.service.find(item => item.code === selected.code);
        if (service) {
          this.$refs.serviceTable.toggleRowSelection(service, true);
          // 同步排序值
          service.sort = selected.sort;
        }
      });
    });
  },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },
      getSetting(){
        var self = this;
          self.getSetting_common({
            "item":'store_clerk',
    
          },function(data){
              // self.service = data.vars.values.service
               self.service = data.vars.values.service.map(item => ({
                    ...item,
                    sort: 0
                  }));
                  self.initSelectedServices(); // 初始化已选服务
          })
      },  
      delService(index){
        this.form.service.splice(index,1)
    },

      serviceChange(e){
        var ind = 0;
        for(var i=0;i<this.form.service.length;i++){
          if(this.form.service[i].code == e.code){
            ind++;
          }
        }
        if(ind<=0){
          this.form.service.push(e);
        }
      
      },
      /*修改*/
      onSubmit() {
        let self = this;
        let form = self.form;
        if (self.select_list && self.select_list.length > 0) {
          form.clerk_id = self.select_list[0].clerk_id
        }
        form.supply_id =  self.form.supplys && self.form.supplys.supply_id?self.form.supplys.supply_id:0;
        form.fx_level = JSON.stringify(self.form.fx_level);
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            StoreApi.editShop(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，门店修改成功',
                  type: 'success'
                });
                self.$router.push('/store/store/index');
              }).catch(error => {
                self.loading = false;
              });
          }
        });
      },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },

      /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*获取参数*/
      getData() {
        let self = this;
        StoreApi.shopDetail({
            store_id: self.form.store_id
          }, true)
          .then(res => {
            self.select_list = res.data.model.shopManager ? [res.data.model.shopManager] : []
            self.form = formatModel(self.form, res.data.model);
            self.form.supplys = res.data.model.supplys;
            self.user_info = res.data.model.user

            self.form.is_check = res.data.model.is_check.value;
            self.form.status = res.data.model.status.value;

          })
          .catch(error => {

          });

      },

      /*上传*/
      openUpload(e) {
        this.file_type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          if(this.file_type=='qrcode'){
            this.form.store_qrcode = e[0].file_path;
          }else{
            this.form.logo = e[0].file_path;
          }

        }
        this.isupload = false;
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开获取用户*/
      openGetUser() {
        this.isOpenGetUser = true
      },
      /*关闭获取用户*/
      closeGetUserFunc(e) {
        if (e.type != 'error') {
          this.select_list = [e.params]
        }
        this.isOpenGetUser = false
      },
      // 打开获取商家
      openGetSupply(){
        this.isOpenGetSupply = true;
      },
      /*关闭获取用户*/
      closeGetSupplyFunc(e) {
        console.log(e)
        if (e.type != 'error') {
          this.form.supplys = e.params[0]
        }
        this.isOpenGetSupply = false
      },

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/store/edit.vue